module.exports = __webpack_public_path__ + "img/jpy.91f2439d.svg";